import styled from 'styled-components';

import { Wix } from './components/integrations/wix';
import { External } from './components/integrations/external';
import { configSelectors } from '../../store';
import { useAppSelector } from '../../lib';

export const Integrations = () => {
  const isWix = useAppSelector(configSelectors.isWix);

  return (
    <IntegrationsWrapper>
      {isWix && <Wix />}

      <External />
    </IntegrationsWrapper>
  );
};

const IntegrationsWrapper = styled.div``;
